/*
 * Which channels the "check for new uploads" scan should look at.
 *
 * Shared by the admin panel and scripts/check-new-uploads.js, so the button
 * and the command line cannot disagree about what gets checked.
 *
 * There is no Channel table, so this is a list rather than a setting. That is
 * a deliberate trade: a table would be the right home for it if channels ever
 * need more than a name and a yes or no, but adding one to store a single flag
 * would be more machinery than the problem deserves. Edit this file to change
 * it, and the reason for each entry goes beside it.
 */

// Channels to leave out entirely, matched on title, case-insensitively.
const SKIP_CHANNELS = [
  // Posts several times a day and almost none of it is a collaboration. It
  // alone accounted for 310 of the 892 videos the first full scan returned,
  // which buried everything else worth looking at.
  'Smosh Pit',
];

/*
 * A channel with only a video or two here is somebody who guested once, not a
 * channel being followed. Kurt Benkert has one video in the database and posts
 * football coaching daily; following him returns hundreds of videos nobody
 * wants.
 */
const MIN_VIDEOS_TO_TRACK = 5;

const skipSet = new Set(SKIP_CHANNELS.map((s) => s.toLowerCase().trim()));

function isSkipped(channelTitle) {
  return skipSet.has(String(channelTitle || '').toLowerCase().trim());
}

/**
 * The channels worth checking, from a map of channelId to
 * { title, count, newest }.
 */
function trackedChannels(byChannel, { min = MIN_VIDEOS_TO_TRACK, includeAll = false } = {}) {
  const kept = [];
  const skippedByName = [];
  const skippedTooFew = [];

  for (const [id, c] of byChannel) {
    if (isSkipped(c.title)) {
      skippedByName.push(c.title || id);
      continue;
    }
    if (!includeAll && c.count < min) {
      skippedTooFew.push(c.title || id);
      continue;
    }
    kept.push([id, c]);
  }
  return { kept, skippedByName, skippedTooFew };
}

module.exports = { SKIP_CHANNELS, MIN_VIDEOS_TO_TRACK, isSkipped, trackedChannels };
